import PhishingUseCaseIllustration from 'images/organization/features/malware/phising-use-case.svg'
import ProtectFinancialLossIllustration from 'images/organization/features/malware/protect-financial-loss.svg'
import EnsureProductivityIllustration from 'images/organization/features/malware/ensure-productivity.svg'
import MaintainSecurityIllustration from 'images/organization/features/malware/maintain-security.svg'
import { UseCaseItem } from 'components/Organization/Features/CommonSections/UseCases/FeatureUseCases'

export const malwareUseCasesData: UseCaseItem[] = [
  {
    image: PhishingUseCaseIllustration,
    title: 'Protection against phishing and malware',
    text: "Prevent harmful content from reaching your employees' devices, significantly reducing the risk of exposure to threats.",
  },
  {
    image: ProtectFinancialLossIllustration,
    title: 'Protect your business against financial loss',
    text: "4 companies are attacked by malware each minute, with 17 million malware instances registered monthly. Don't let your business be the next victim.",
  },
  {
    image: EnsureProductivityIllustration,
    title: 'Ensure productivity across your team',
    text: 'Secure devices mean no disruptions caused by malware infections, keeping employees productive and reducing IT downtime.',
  },
  {
    image: MaintainSecurityIllustration,
    title: 'Maintain security and compliance standards',
    text: `Control D's malware protection supports compliance with GDPR and HIPAA by preventing unauthorized access to sensitive data, reducing the risk of data breaches.`,
  },
]

export default malwareUseCasesData
